var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content theme" },
            [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-7 mt-5" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-5 mt-md-5" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "stick-in-parent",
                          rawName: "v-stick-in-parent"
                        }
                      ]
                    },
                    [
                      _c(
                        "h1",
                        {
                          staticClass: "h2 title",
                          attrs: { "data-testing": "item-name" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("itemName")(_vm.currentVariation))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.currentVariation.filter.hasManufacturer
                        ? _c("div", { staticClass: "manufacturer mb-3" }, [
                            _vm.currentVariation.item.manufacturer.url != ""
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        _vm.currentVariation.item.manufacturer
                                          .url
                                    }
                                  },
                                  [
                                    _vm.currentVariation.item.manufacturer
                                      .logo != ""
                                      ? _c("img", {
                                          staticClass: "img-fluid",
                                          attrs: {
                                            src:
                                              _vm.currentVariation.item
                                                .manufacturer.logo,
                                            alt:
                                              _vm.currentVariation.item
                                                .manufacturer.externalName
                                          }
                                        })
                                      : _c("p", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer.externalName
                                            )
                                          }
                                        })
                                  ]
                                )
                              : _c("div", [
                                  _vm.currentVariation.item.manufacturer.logo !=
                                  ""
                                    ? _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src:
                                            _vm.currentVariation.item
                                              .manufacturer.logo,
                                          alt:
                                            _vm.currentVariation.item
                                              .manufacturer.externalName
                                        }
                                      })
                                    : _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.externalName
                                          )
                                        }
                                      })
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("tag-list"),
                      _vm._v(" "),
                      _vm.isShortDescriptionActive &&
                      _vm.currentVariation.texts.shortDescription !== ""
                        ? _c("p", {
                            staticClass: "single-description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.shortDescription
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-5" }, [
                        _c(
                          "span",
                          { staticClass: "articlenumber small text-dark" },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemNumber"
                                  )
                                ) + " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.currentVariation.variation.number)
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.attributes.length || Object.keys(_vm.units).length
                        ? _c(
                            "div",
                            { staticClass: "mb-3" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variation.bundleType === "bundle"
                        ? _c("item-bundle", {
                            attrs: {
                              "bundle-type":
                                _vm.currentVariation.variation.bundleType,
                              "bundle-components":
                                _vm.currentVariation.bundleComponents
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("before-price"),
                      _vm._v(" "),
                      _vm.currentVariation.filter.isSalable &&
                      _vm.variationGroupedProperties.length
                        ? _c("div", [_c("order-property-list")], 1)
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.currentVariation.variationProperties, function(
                        property
                      ) {
                        return _vm.currentVariation.variationProperties
                          ? [
                              _vm._l(property.properties, function(
                                property,
                                index
                              ) {
                                return property.id == 40
                                  ? [
                                      _c(
                                        "b",
                                        {
                                          staticClass:
                                            "h4 font-weight-bold mb-3 d-block"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "nextorchVueTheme::Single.CustomTechnicalData"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            property.values.value
                                          )
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              })
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "download-wrapper d-flex mb-5" },
                        [
                          _vm._l(
                            _vm.currentVariation.variationProperties,
                            function(property) {
                              return _vm.currentVariation.variationProperties
                                ? [
                                    _vm._l(property.properties, function(
                                      property,
                                      index
                                    ) {
                                      return property.id == 43 ||
                                        property.id == 45
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "d-block mr-3 mt-3",
                                                attrs: {
                                                  href: property.values.value,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-center color-dark small font-weight-bold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        property.names.name
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("img", {
                                                  staticClass:
                                                    "pdf-icon img-fluid d-block mx-auto mb-2",
                                                  attrs: {
                                                    src:
                                                      "https://cdn02.plentymarkets.com/gw81lpaq889b/frontend/webshop/images/static/icons/2021/pdficon.svg",
                                                    alt: property.names.name
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    })
                                  ]
                                : _vm._e()
                            }
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("graduated-prices"),
                      _vm._v(" "),
                      _c("item-price", {
                        attrs: {
                          "show-cross-price": _vm.isRecommendedPriceActive
                        }
                      }),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _c("item-availability"),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("before-add-to-basket")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-sm-7 col-md-12 col-lg-8 my-3"
                              },
                              [
                                _c("add-to-basket", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties": _vm.currentVariation.properties.filter(
                                      function(prop) {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                    "has-order-properties":
                                      _vm.currentVariation.hasOrderProperties,
                                    "has-required-order-property":
                                      _vm.currentVariation
                                        .hasRequiredOrderProperty,
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("after-add-to-basket")],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isWishListEnabled
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("add-to-wish-list", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket"),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "vat small text-muted" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemFootnote1"
                                )
                              ) +
                              " "
                          ),
                          _vm.showNetPrices
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemExclVAT"
                                    )
                                  )
                                )
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemInclVAT"
                                    )
                                  )
                                )
                              ],
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemExclusive"
                                )
                              ) +
                              "\n              "
                          ),
                          _vm.hasShippingCostsCategoryId
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "modal",
                                    href: "#shippingscosts"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _c("a", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemShippingCosts"
                                    )
                                  )
                                )
                              ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("additional-content-after-vat"),
                      _vm._v(" "),
                      _vm._l(_vm.currentVariation.variationProperties, function(
                        property
                      ) {
                        return _vm.currentVariation.variationProperties
                          ? [
                              _vm._l(property.properties, function(
                                property,
                                index
                              ) {
                                return property.id == 41
                                  ? [
                                      _c("div", { staticClass: "mt-5" }, [
                                        _c(
                                          "b",
                                          {
                                            staticClass:
                                              "h4 font-weight-bold mb-3 d-block"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "nextorchVueTheme::Single.YoutubeHeadline"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "video-container mb-5 mt-4"
                                          },
                                          [
                                            _c("span", [
                                              _c("iframe", {
                                                attrs: {
                                                  src: property.values.value,
                                                  allow:
                                                    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                                  allowfullscreen: "",
                                                  width: "560",
                                                  height: "315",
                                                  frameborder: "0"
                                                }
                                              })
                                            ])
                                          ]
                                        )
                                      ])
                                    ]
                                  : _vm._e()
                              })
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "my-5" }, [
                  _c(
                    "ul",
                    { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
                    [
                      _vm.isDescriptionTabActive
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link active",
                                attrs: {
                                  "data-toggle": "tab",
                                  href:
                                    "#details-" +
                                    _vm.currentVariation.variation.id,
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemDescription"
                                    )
                                  )
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTechnicalDataTabActive
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active:
                                    !_vm.isDescriptionTabActive &&
                                    _vm.isTechnicalDataTabActive
                                },
                                attrs: {
                                  "data-toggle": "tab",
                                  href:
                                    "#data-" +
                                    _vm.currentVariation.variation.id,
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemTechnicalData"
                                    )
                                  )
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEuResponsibleTabShown
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                attrs: {
                                  "data-toggle": "tab",
                                  href: "#eu-responsible",
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemEuResponsiblePerson"
                                    )
                                  )
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isManufacturerTabShown
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                attrs: {
                                  "data-toggle": "tab",
                                  href: "#manufacturer",
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemManufacturer"
                                    )
                                  )
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("add-detail-tabs")
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab-content overflow-hidden" },
                    [
                      _vm.isDescriptionTabActive
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-pane active overflow-auto",
                              attrs: {
                                id:
                                  "details-" +
                                  _vm.currentVariation.variation.id,
                                role: "tabpanel"
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "my-4",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.description
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTechnicalDataTabActive
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-pane overflow-auto",
                              class: {
                                active:
                                  !_vm.isDescriptionTabActive &&
                                  _vm.isTechnicalDataTabActive
                              },
                              attrs: {
                                id: "data-" + _vm.currentVariation.variation.id,
                                role: "tabpanel"
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "my-4",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.technicalData
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEuResponsibleTabShown
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-pane overflow-auto",
                              attrs: { id: "eu-responsible", role: "tabpanel" }
                            },
                            [
                              _c("div", { staticClass: "my-4" }, [
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsibleName
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsibleStreet
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsibleHouseNo
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsiblePostCode
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsibleTown
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentVariation.item.manufacturer
                                    .responsibleCountryObject
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer
                                                .responsibleCountryObject.name
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsibleEmail
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsiblePhoneNo
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .responsibleContactUrl
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isManufacturerTabShown
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-pane overflow-auto",
                              attrs: { id: "manufacturer", role: "tabpanel" }
                            },
                            [
                              _c("div", { staticClass: "my-4" }, [
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .name
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .legalName
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .street
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .houseNo
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .postcode
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .town
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentVariation.item.manufacturer
                                    .countryObject
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer.countryObject.name
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .email
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .url
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .phoneNumber
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .faxNumber
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "p-0" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .contactUrl
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("add-detail-tabs-content")
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._t("cross-selling-accessory"),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }